var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1142 34.2857V38.4H41.6C43.1148 38.4 44.3428 37.172 44.3428 35.6571V2.74286C44.3428 1.22802 43.1148 0 41.6 0H16.9142C15.3994 0 14.1714 1.22802 14.1714 2.74286V6.85714H18.2857V5.48571C18.2857 4.7283 18.8997 4.11429 19.6571 4.11429H38.8571C39.6145 4.11429 40.2285 4.7283 40.2285 5.48571V32.9143C40.2285 33.6717 39.6145 34.2857 38.8571 34.2857H36.1142ZM22.4 9.59998V20.5714H33.3714V46.6285C33.3714 47.386 32.7574 48 32 48H4.57138C3.81396 48 3.19995 47.386 3.19995 46.6285V10.9714C3.19995 10.214 3.81396 9.59998 4.57138 9.59998H22.4ZM7.31424 13.7142V16.4571H18.2857V13.7142H7.31424ZM7.31424 19.1999V21.9428H18.2857V19.1999H7.31424ZM7.31424 24.6856V27.4285H29.2571V24.6856H7.31424ZM7.31424 30.1714V32.9142H29.2571V30.1714H7.31424ZM7.31424 35.6572V38.4001H29.2571V35.6572H7.31424ZM7.31424 41.1428V43.8857H22.4V41.1428H7.31424ZM25.1428 9.59998L33.3714 17.8285H25.1428V9.59998Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetLibrary);
export default __webpack_public_path__ + "static/media/asset_library.0bcb2780ea2d4bbe17eea284eec6438a.svg";
export { ForwardRef as ReactComponent };